/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScrapeLinkMetadataRequest
 */
export interface ScrapeLinkMetadataRequest {
    /**
     * 
     * @type {string}
     * @memberof ScrapeLinkMetadataRequest
     */
    link: string;
}

/**
 * Check if a given object implements the ScrapeLinkMetadataRequest interface.
 */
export function instanceOfScrapeLinkMetadataRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "link" in value;

    return isInstance;
}

export function ScrapeLinkMetadataRequestFromJSON(json: any): ScrapeLinkMetadataRequest {
    return ScrapeLinkMetadataRequestFromJSONTyped(json, false);
}

export function ScrapeLinkMetadataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScrapeLinkMetadataRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'link': json['link'],
    };
}

export function ScrapeLinkMetadataRequestToJSON(value?: ScrapeLinkMetadataRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'link': value.link,
    };
}

